module.exports = __webpack_public_path__ + "img/treasure-primary-show.88f588bc.png";